import './AdPodPreview.scss';

import React, { useMemo } from 'react';
import { Droppable } from 'react-beautiful-dnd';

import { PodAlignment } from '../../../apis/graphql';
import bem from '../../../utils/bem';
import type { SequenceAdV5 } from '../types';
import { toPodPreviewDroppableId } from './adPodPreviewUtils';
import PodAd from './PodAd';

const [block, element] = bem('ad-pod-preview');
const podAlignmentLabels = Object.values(PodAlignment);

type AdPodPreviewProps = {
  title: string;
  podPosition: string;
  sequenceIndex: number;
  ads: SequenceAdV5[];
};

const AdPodPreview = ({ title, podPosition, sequenceIndex, ads }: AdPodPreviewProps): JSX.Element => {
  const adsByAlignment = useMemo((): Record<string, SequenceAdV5[]> => {
    return podAlignmentLabels.reduce((acc, alignment) => {
      acc[alignment] = ads.filter((ad) => ad.adSequence?.podAlignment === alignment);
      return acc;
    }, {} as Record<string, SequenceAdV5[]>);
  }, [ads]);

  return (
    <div className={block()}>
      <div className={element('title')}>
        <p>{title}</p>
      </div>
      <div className={element('content')}>
        {podAlignmentLabels.map(
          (podAlignmentLabel): JSX.Element => (
            <div key={`${title}-${podAlignmentLabel}`} className={element('alignment-section')}>
              <p className={element('alignment-label')}>{podAlignmentLabel}</p>
              <Droppable
                droppableId={toPodPreviewDroppableId(sequenceIndex, podPosition, podAlignmentLabel)}
                type="pod-ad"
              >
                {(provided): React.ReactElement => (
                  <div className={element('alignment-items')} ref={provided.innerRef} {...provided.droppableProps}>
                    {adsByAlignment[podAlignmentLabel]?.map(
                      (ad, adIndex): JSX.Element => (
                        <PodAd key={ad.id} ad={ad} index={adIndex} />
                      )
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AdPodPreview;
